import { i18n } from '@/locales';
const lc = 'views.hub_management.';
// 공유콜색상유형(0: 디폴트, 1: 컬러없음, 2: 기사설정)
const shareCallColorTypeOptionList = [
    '0',
    '1',
    '2',
];
export default shareCallColorTypeOptionList.map((code, index) => ({
    text: i18n.t(`${lc}hub_configuration.share_call_color_type_list[${index}]`),
    value: code,
}));
